import type { ComponentType } from 'react'
import styled from 'styled-components'

import type { TextProps } from '@awazevr/design-system.components.text'
import { Text } from '@awazevr/design-system.components.text'

const StylableText = Text as unknown as ComponentType<TextProps>

export const StyledPriceInfo = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.25rem;
`

export const StyledStartDate = styled(StylableText)`
  font-weight: 500;
`

export const StyledDivider = styled(StylableText)`
  font-size: 0.6rem;
  opacity: 0.6;
  padding: 0 0.125rem;
`

export const StyledNights = styled(StylableText)`
  font-weight: 500;
`

export const StyledFromLabel = styled(StylableText)`
  text-transform: lowercase;
`
